<template>
  <st-scrolly>
    <template v-slot:background="{slideIndex, enter, exit}">
      <div class="scrolly-content">
        <scrolly-svg v-if="!attributes.mode || attributes.mode ==='svg'" :rootFolder="attributes.value" :index="slideIndex + 1"/>
        <scrolly-image v-else-if="attributes.mode === 'image'"
          :attributes="attributes"
          :scrollInfo="{slideIndex, enter, exit}"/>
      </div>
    </template>

    <div class="slide" :style="slideStyle(i)" v-for="(slideText, i) in attributes.p" :key="i">
      <p :style="slideTextStyle(i)" v-markdown="slideText"></p>
    </div>
  </st-scrolly>
</template>

<script>
import StScrolly from './StScrolly.vue'
import ScrollyImage from './ScrollyImage.vue'
import ScrollySvg from './ScrollySvg.vue'

export default {
  name: 'Scrolly',
  props: ['attributes'],
  data () {
    return {
      initHeight: this.$window.innerHeight
    }
  },
  components: {
    StScrolly,
    ScrollyImage,
    ScrollySvg
  },
  computed: {
    slideHeight () {
      return this.initHeight < 800 ? 800 : this.initHeight
    }
  },
  methods: {
    slideStyle (i) {
      const isLast = i === this.attributes.p.length - 1
      return {
        height: (isLast ? this.slideHeight * 2 : this.slideHeight) + 'px',
        paddingBottom: isLast ? this.slideHeight : 0
      }
    },
    slideTextStyle (i) {
      const isLast = i === this.attributes.p.length - 1
      return {
        // bottom: 0
        bottom: isLast ? this.slideHeight + 'px' : 0
      }
    }
  }
}
</script>

<style lang="scss">
.component-content {
  &:not(.fullwidth) {
    .background {
      @include container;
    }
  }
}

.st-scrolly {
  .background-container {
    .background > * {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .slide-container {
    @include container;

    .slide {
      position: relative;

      p {
        position: absolute;
        bottom: 0;
        font-size: 20px;
        line-height: 31px;
        color: $black;
        background-color: #FFFFFF;
        padding: 15px 15px 20px;
        margin: 10px;
        max-width: 400px;

        @include breakpoint($d_medium) {
          font-size: 22px;
        }
      }
    }
  }
}
</style>
